<template>
	<div
		class="d-flex flex-column h-100"
	>
		<div class="px-6">
			<CompanySwitcher/>
			<div class="pb-2"/>
			<ao-btn
				:to="{ name: 'CreateCompanyPage' }"
				variant="flat"
				active-color="primary"
				class="rounded content-left left-sidebar-btn"
			>
				{{ $t('Create company') }}
			</ao-btn>
		</div>
		<v-list
			width="255"
			class="px-6 d-flex flex-column"
		>
			<p class="ao-p2-medium ao-text-secondary-color my-3">{{ $t('User settings') }}</p>
			<ao-btn
				v-for="item in userLinks"
				:key="`link-${item.name}`"
				:to="{ name: item.meta.defaultChild || item.name }"
				variant="flat"
				active-color="primary"
				class="rounded content-left left-sidebar-btn"
			>
				{{ item.meta.titleTranslationKey ? $t(item.meta.titleTranslationKey) : item.meta.title }}
			</ao-btn>
		</v-list>
		<v-list
			width="255"
			class="px-6 d-flex flex-column"
		>
			<ao-btn
				variant="flat"
				active-color="primary"
				class="rounded content-left left-sidebar-btn"
				@click="logoutUser"
			>
				{{ $t('Logout') }}
			</ao-btn>
		</v-list>
		<v-spacer/>
		<div class="px-6 pb-6">
			<LocaleSwitcher />
		</div>
	</div>
</template>

<script setup>
import useAuth from '@/composables/useAuth'

import { LocaleSwitcher } from '@ao/i18n'
import CompanySwitcher from '@/components/company/CompanySwitcher.vue'

import { USER_PAGES } from '@/config/router/routerConfig'

const {
	logoutUser,
} = useAuth()

const userLinks = USER_PAGES
</script>

<style lang="scss"></style>
